import { GET_SIZE_AND_WEIGHT } from "../Components/SizeAndWeightFrame/Query/SizeAndWeightQuery";
import { getValueFromPath } from "../IndexedDb/util.js";
import { isSizeAndWeightEmpty } from "./isSizeAndWeightEmpty";

//the only validation so far is to ensure the Size And Weight frame is locked if it exists
export const validateSizeAndWeight = async (incident, userId, client) => {
  let sizeAndWeight = incident?.sizeAndWeight;

  let res = {
    isValid: true,
    errors: [],
  };
  if (!incident) {
    res.isValid = false;
    res.errors.push("Incident is required");
    return res;
  }
  if (!userId) {
    res.isValid = false;
    res.errors.push("User ID is required");
    return res;
  }

  //there is no sizeAndWeight object
  if (!sizeAndWeight?.id) return res;

  //check if sizeAndWeight has a key called locked
  const hasLockedProperty =
    sizeAndWeight && Object.keys(sizeAndWeight).includes("locked");

  //the sizeAndWeight ID exists and the frame is locked
  if (sizeAndWeight?.id && hasLockedProperty && sizeAndWeight?.locked)
    return res;

  //has the sizeAndWeight ID but not the locked status
  if (sizeAndWeight?.id && !hasLockedProperty) {
    console.log(
      "Incident Size and Weight data not yet fetched. Fetching the data."
    );
    try {
      const { data } = await client.query({
        query: GET_SIZE_AND_WEIGHT,
        variables: { sizeAndWeightId: sizeAndWeight?.id, originatorId: userId },
        context: { timeout: 60000 },
        fetchPolicy: "network-only",
      });
      sizeAndWeight = getValueFromPath(data, "getSizeAndWeight");
    } catch (err) {
      console.error("Error getting the size and weight data", err);
      res.isValid = false;
      res.errors.push("Error getting the size and weight data", err);
      return res;
    }
  }

  const isSwEmpty = isSizeAndWeightEmpty(sizeAndWeight);
  //Mobile adds an axle group and axle to the size and weight frame when the frame is opened
  if (isSwEmpty) {
    return res;
  }

  if (!sizeAndWeight?.locked) {
    res.isValid = false;
    res.errors.push(
      "You cannot approve an incident with an unlocked Size and Weight frame. Please navigate to the Size and Weight frame and lock the data."
    );
    return res;
  }

  return res;
};
